//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ValidationMessages from './ValidationMessages.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TextareaGroup',
  components: {
    ValidationMessages
  },
  props: {
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    validation: {
      type: Object,
      default: null
    },
    rows: {
      type: Number,
      default: 3
    },
    maxRows: {
      type: Number,
      default: 6
    }
  },
  computed: {
    state () {
      if (this.validation) {
        return this.validation.$dirty ? !this.validation.$error : null
      }

      return null
    }
  }
}
